/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes, { func } from 'prop-types';
import moment from 'moment';
import {
  Form,
  Col,
  Popconfirm,
  Row,
  Spin,
  Button,
  notification,
  Anchor,
} from 'antd';
import {
  LoadingOutlined,
} from '@ant-design/icons';
// import './ProjectInfo.css';
import {
  updateCoexecutorProject,
  getCoexecutorsProjectById,
  generateCoexecutorAgreement,
  getAgreementData,
  createUser,
} from '../../../../utils/http';
import getUserRole from '../../../../utils/localeStorage/getUserRole';
import { approveValidationCoexecutorsAgreement } from '../../../../utils/approveValidationCoexecutorsAgreement';
import { getCoexecutorSDates, getCoexecutorNIRDates } from './utils';
import { UsersSelect } from '../ProjectInfo/UsersSelect';
import AddUserModal from '../ProjectInfo/AddUserModal';
import { NirProject } from './NirProject';
import { SProject } from './SProject';
import { numberToWords } from '../../../../utils/numberToWords';
import { DocumentsList } from '../Documents/Documents';
// import PlanRow from './PlanRow';


function CoexecutorProjectInfo({ data, onRedirectToList }) {
  const [loading, setLoading] = useState(false);
  const [coexecutorData, setCoexecutorData] = useState(data);
  const formRef = useRef(null);

  const [showUsersSearch, setShowUsersSearch] = useState(false);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    setCoexecutorData(data);
  }, [data]);

  const fetchAgreementData = async () => {
    const resp = await getAgreementData();

    const agreement = resp.payload.find(
      (el) => el.application.id === data.application2_id.id,
    );

    return agreement.id;
  };

  const handleCreateNewUser = async (values) => {
    const valuesWithID = {
      ...values,
      id: values.email.toLowerCase(),
      email: values.email.toLowerCase(),
      coex_create: true,
      theme: coexecutorData.coexecutorsPersonId.theme,
      display_id: coexecutorData.display_id,
    };

    const resp = await createUser(valuesWithID);

    if (resp.status === 'OK') {
      setSelectedUser(valuesWithID);
      setShowAddUserModal(false);
    }
  };

  const steps = () => {
    if (coexecutorData.isNIR) {
      return [
        {
          step: 1,
          active: coexecutorData.coexecutorsPersonId.isStep1,
          year: 2025,
          summ: coexecutorData.coexecutorsPersonId.step1Sum || 0,
        },
        {
          step: 2,
          active: coexecutorData.coexecutorsPersonId.isStep2,
          year: 2025,
          summ: coexecutorData.coexecutorsPersonId.step2Sum || 0,
        },
        {
          step: 3,
          active: coexecutorData.coexecutorsPersonId.isStep3,
          year: 2026,
          summ: coexecutorData.coexecutorsPersonId.step3Sum || 0,
        },
        {
          step: 4,
          active: coexecutorData.coexecutorsPersonId.isStep4,
          year: 2026,
          summ: coexecutorData.coexecutorsPersonId.step4Sum || 0,
        },
        {
          step: 5,
          active: coexecutorData.coexecutorsPersonId.isStep5,
          year: 2027,
          summ: coexecutorData.coexecutorsPersonId.step5Sum || 0,
        },
        {
          step: 6,
          active: coexecutorData.coexecutorsPersonId.isStep6,
          year: 2027,
          summ: coexecutorData.coexecutorsPersonId.step6Sum || 0,
        },
      ];
    }

    if (coexecutorData.isS) {
      return [
        {
          step: 1,
          active: coexecutorData.coexecutorsPersonId.isStep1 || coexecutorData.coexecutorsPersonId.isStep2,
          year: 2025,
          summ: (coexecutorData.coexecutorsPersonId.step1Sum || 0) + (coexecutorData.coexecutorsPersonId.step2Sum || 0),
        },
        {
          step: 2,
          active: coexecutorData.coexecutorsPersonId.isStep3 || coexecutorData.coexecutorsPersonId.isStep4,
          year: 2026,
          summ: (coexecutorData.coexecutorsPersonId.step3Sum || 0) + (coexecutorData.coexecutorsPersonId.step4Sum || 0),
        },
        {
          step: 3,
          active: coexecutorData.coexecutorsPersonId.isStep5 || coexecutorData.coexecutorsPersonId.isStep6,
          year: 2027,
          summ: (coexecutorData.coexecutorsPersonId.step5Sum || 0) + (coexecutorData.coexecutorsPersonId.step6Sum || 0),
        },
      ];
    }

    return [];
  };

  const saveData = async () => {
    const values = formRef.current.getFieldsValue();

    if (values.workType === 'workTypeNIOKR') {
      values.workTypeNIOKR = true;
      values.workTypeNIR = false;
    }

    if (values.workType === 'workTypeNIR') {
      values.workTypeNIR = true;
      values.workTypeNIOKR = false;
    }

    delete values.workType;
    delete values.agreement_id;
    delete values.application2_id;

    values.smeta = JSON.stringify(values.smeta);

    if (!data.agreement_id) {
      const id = await fetchAgreementData();
      values.agreement_id = id;
    }

    if (!values.etap1_documents) {
      values.etap1_documents = JSON.stringify([{}]);
    }

    if (!values.etap2_documents) {
      values.etap2_documents = JSON.stringify([{}]);
    }

    if (!values.etap3_documents) {
      values.etap3_documents = JSON.stringify([{}]);
    }

    if (!values.etap4_documents) {
      values.etap4_documents = JSON.stringify([{}]);
    }

    if (!values.etap5_documents) {
      values.etap5_documents = JSON.stringify([{}]);
    }

    if (!values.etap6_documents) {
      values.etap6_documents = JSON.stringify([{}]);
    }

    // Parsing agreement and breaking into separate fields
    const momentDate = moment(values.agreement_date, 'DD MMMM YYYY');

    values.date_day = momentDate.format('DD');
    // eslint-disable-next-line prefer-destructuring
    values.date_month = momentDate.format('DD MMMM').split(' ')[1];
    values.date_year = momentDate.format('YYYY');

    delete values.agreement_date;

    if (!coexecutorData.isS && !coexecutorData.isNIR) {
      values.isNIR = true;
      values.isS = false;
    }

    // Getting dates from plan
    const planDates = steps().reduce((acc, el) => {
      const datesByStep = () => {
        if (coexecutorData.isNIR) {
          return getCoexecutorNIRDates(coexecutorData, el.step);
        }

        if (coexecutorData.isS) {
          return getCoexecutorSDates(coexecutorData, el.step);
        }

        return [];
      };

      return [...acc, {
        step: el.step,
        dates: el.active ? [{
          date: datesByStep(),
        }] : [{}],
      }];
    }, []);

    values.planGrpaphicDates = JSON.stringify(planDates);

    if (coexecutorData.isS) {
      const stepsJSON = structuredClone(steps()).filter((el) => el.active).map((el) => ({
        ...el,
        summPropis: numberToWords(el.summ),
      }));

      values.steps = JSON.stringify(stepsJSON);

      values.step1SumMajor = (coexecutorData.coexecutorsPersonId.step1Sum || 0) + (coexecutorData.coexecutorsPersonId.step2Sum || 0);
      values.step2SumMajor = (coexecutorData.coexecutorsPersonId.step3Sum || 0) + (coexecutorData.coexecutorsPersonId.step4Sum || 0);
      values.step3SumMajor = (coexecutorData.coexecutorsPersonId.step5Sum || 0) + (coexecutorData.coexecutorsPersonId.step6Sum || 0);
    }

    try {
      await updateCoexecutorProject({
        ...values,
        id: coexecutorData?.id,
      });
      const newData = await getCoexecutorsProjectById(coexecutorData.id);
      setCoexecutorData(newData.payload[0]);
      return true;
    } catch {
      return false;
    }
  };

  const onSaveForm = async () => {
    setLoading(true);
    const isSaved = await saveData();

    if (isSaved) {
      notification.success({
        message: 'Сохранено',
      });
    } else {
      notification.error({
        message: 'Произошла ошибка. Попробуйте еще раз',
      });
    }
    setLoading(false);
  };

  const generateAgreement = async () => {
    const values = formRef.current.getFieldsValue();

    const { isError, tabs } = approveValidationCoexecutorsAgreement(values, coexecutorData.coexecutorsPersonId, coexecutorData);

    if (isError) {
      notification.error({
        message:
          'Ошибка завершения заполнения. Заполните обязательные поля и исправьте ошибки!',
        style: { width: 1000 },
        duration: 100,
        description: (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              overflowY: 'scroll',
              height: '80vh',
            }}
          >
            {tabs.map((tab) => {
              if (tab.errorFields.length > 0) {
                return (
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
                      {tab.label}
                    </div>
                    <ul>
                      {tab.errorFields.map((f) => (
                        <li key={f}>{f}</li>
                      ))}
                    </ul>
                  </div>
                );
              }
              return null;
            })}
          </div>
        ),
      });
      setLoading(false);
      return false;
    }

    // notification.info({
    //   message: 'Функционал в разработке',
    // });

    setLoading(true);
    await saveData();

    const req = await generateCoexecutorAgreement({
      id: coexecutorData.id,
      generate: true,
    });

    if (req.file) {
      window.open(req.file, '_blank');
    } else {
      notification.error({
        message: 'Произошла ошибка при генерации документа. Попробуйте еще раз',
      });
    }

    setLoading(false);

    return true;
  };

  const updateProjectUser = async () => {
    try {
      await updateCoexecutorProject({
        user: selectedUser.id,
        id: coexecutorData?.id,
      });
      const newData = await getCoexecutorsProjectById(coexecutorData.id);
      setCoexecutorData(newData.payload[0]);
      notification.success({
        message: 'Сохранено',
      });
      setSelectedUser(null);
      setShowUsersSearch(false);
    } catch {
      notification.error({
        message: 'Произошла ошибка. Попробуйте еще раз',
      });
    }
  };


  return (
    <>
      {loading ? (
        <Spin
          indicator={
            <LoadingOutlined style={{ fontSize: 100, zIndex: 100 }} spin />
          }
          style={{ position: 'absolute', top: '40%', left: '40%' }}
        />
      ) : (
        <Form ref={formRef} className="project-info">
          <Row gutter={24} style={{ marginBottom: '15px', justifyContent: 'flex-end' }}>
            <Col span={16}>
              {coexecutorData.isNIR && <NirProject coexecutorData={coexecutorData} formRef={formRef} onSaveForm={onSaveForm} />}
              {coexecutorData.isS && <SProject coexecutorData={coexecutorData} formRef={formRef} onSaveForm={onSaveForm} />}
            </Col>
            <Col span={8} style={{ marginTop: '20px' }}>
              <Anchor offsetTop={20}>
                {getUserRole() === 'bigAdmin' && (
                <>
                  {showUsersSearch && (
                  <>
                    <div style={{ marginBottom: '15px' }}>
                      Текущий пользователь:
                      {coexecutorData?.user ? `${coexecutorData?.user?.fullName} (${coexecutorData?.user?.email})` : 'Не выбран'}
                    </div>
                    <UsersSelect selectedUser={selectedUser} onAddNewUser={() => setShowAddUserModal(true)} onUserSelect={setSelectedUser} />
                    {selectedUser && (
                    <Popconfirm
                      title="Вы уверены, что хотите присвоить проект выбранному пользователю?"
                      onConfirm={updateProjectUser}
                      okText="Да"
                      cancelText="Нет"
                    >
                      <Button style={{ width: '100%', marginTop: '15px', marginBottom: '15px' }} type="primary">Сохранить</Button>
                    </Popconfirm>
                    )}
                    <Button type="danger" onClick={() => setShowUsersSearch(false)} style={{ width: '100%', marginTop: '15px', marginBottom: '15px' }}>Отмена</Button>
                  </>
                  )}


                  {showAddUserModal && (
                  <AddUserModal
                    onCloseModal={() => setShowAddUserModal(false)}
                    onSaveModal={handleCreateNewUser}
                  />
                  )}
                </>
                )}
                {!showUsersSearch && (
                <>
                  <Button
                    type="primary"
                    onClick={onSaveForm}
                    style={{ marginRight: '15px' }}
                  >
                    Сохранить
                  </Button>
                  {getUserRole() === 'bigAdmin' && (
                  <>
                    <Button
                      type="primary"
                      onClick={generateAgreement}
                      style={{ marginRight: '15px' }}
                    >
                      Сформировать Договор
                    </Button>
                    <Button type="danger" onClick={() => setShowUsersSearch(true)} style={{ marginBottom: '15px', marginTop: '15px' }}>Присвоить проект другому пользователю</Button>
                  </>
                  )}
                </>
                )}

                <DocumentsList getMethod={getCoexecutorsProjectById} postMethod={updateCoexecutorProject} applicationProp={coexecutorData} />
              </Anchor>
            </Col>
          </Row>
        </Form>
      )}
    </>
  );
}

CoexecutorProjectInfo.propTypes = {
  data: PropTypes.shape().isRequired,
  onRedirectToList: PropTypes.func.isRequired,
  // updateOriginalObject: PropTypes.func.isRequired,
};

export default CoexecutorProjectInfo;
